import { render, staticRenderFns } from "./qxtbcaiji.vue?vue&type=template&id=4511fdbe&scoped=true"
import script from "./qxtbcaiji.js?vue&type=script&lang=js&external"
export * from "./qxtbcaiji.js?vue&type=script&lang=js&external"
import style0 from "./qxtbcaiji.scss?vue&type=style&index=0&id=4511fdbe&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4511fdbe",
  null
  
)

export default component.exports